// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.APO__box-shadow {
    /* box-shadow: 0px 0px 4px rgba(39, 45, 61, 0.1), 0px 0px 4px rgba(39, 45, 61, 0.06); */
    border: 1px solid #e0eaf9;
}
.APO__custhaserror {
    color: #e22727;
    font-size: 14px;
    margin-top: -13px;
    margin-bottom: 16px;
}
.APO__hover:hover, .service-wrapper.selected, .APO__boxed.selected {
    background-color: #fafafa;
    border-color: #1e75ff;
}
.APO__hover:hover * {
    color: #3c5d95;
}
.APO__hover:hover .gray-badge {
    background-color: #1e75ff;
    color: #fff;
}
.APO__hover:hover svg path{
    fill: #1e75ff!important;
}
.APO__title {
    text-transform: capitalize!important;
    color: #252525;
}
.APO__mutetext {
    font-size: 14px;
}
.gray-badge {
    /* position: absolute;
    right: 0;
    bottom: 16px; */
    background-color: #eaeaea;
    border-radius: 5px;
    padding: 1px 8px;
    font-size: 14px;
    line-height: normal;
    color: #242627;
}
.APO__typeicon {
    font-size: 28px;
    color: #49505f;
}
.APO__OptionIcon {
    font-size: 24px;
    color: #49505f;
}

/* staff css */
.__selectStaff hr {
    width: 30px;
    height: 2px;
    background-color: #ccc;
    border-radius: 4px;
    border: none;
}
.__Staffname:first-letter, .__StaffRole:first-letter {
    text-transform: capitalize!important;
}

/* boxed  design css */
.APO__boxedlayout .APO__boxed {
    width: calc(50% - 8px);
    word-break: break-word;
}

/* booking slots */
.APO__Timeslots {
    padding: 8px;
    width: 100%;
    cursor: pointer;
}
.APO__Timeslots:not(.breakHour){
    color: #1e75ff;
    border: 1px solid #1e75ff;
}
.APO__Timeslots:hover:not(.breakHour), .APO__Timeslots.selected:not(.breakHour) {
    color: #fff;
    background-color: #1e75ff;
}
.APO__Timeslots.breakHour {
    cursor: not-allowed;
    background-color: #eee;
    border-color: var(--gray-100);
}

/* order detail box css */
.APO__insertOrderD {
    background-color: #fafafa;
    position: absolute;
    bottom: -100%;
    left: 0;
    right: 0;
    border-top: 1px solid #e0eaf9;
    border-radius: 16px 16px 0px 0px;  
    overflow: hidden;
    max-height: 100%;
}
.APO__insertOrderD.orderDminimized .APO__roundedicon svg {
    transform: rotate(180deg);
}
/* .APO__insertOrderD.orderDminimized {
    bottom: -145px !important;
}
.APO__insertOrderD.orderDminimized .APO__orderDContent, .APO__insertOrderD.orderDminimized .APO__bookingBtn {
    display: none;
} */
.APO__insertOrderD.fillcontactDetail {
    /* height: calc(100% - 67px); */
    /* top: 64px; */
    border-radius: 0px;
    overflow-y: auto;
    border-top: none;
}
/* .APO__insertOrderD.fillcontactDetail::-webkit-scrollbar {
    display: none;
} */
 .tryAgainBtn{
    background-color: #f34e52;   
    color: #fff;
    font-size: 17px;
    cursor: pointer;
 }
.APO__orderDright {
    max-width: 60px;
    word-wrap: break-word;
}
.APO__orderDetail .APO__title{
    font-size: 17px!important;
}
.APO__AllbooikgList .addnewAPO {
    position: absolute;
    right: 10px;
    left: auto;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    bottom: 32px;
    padding: 0;
    z-index: 1;
}
.APO__bookingBtn{
    background-color: #1e75ff!important;   
    color: #fff!important;
    cursor: pointer!important;
}
.APO__bookingBtn:disabled {
    opacity: .5!important;
    cursor: not-allowed!important;
}
.APO__insertOrderD.fillcontactDetail .APO__orderDetail{
    padding-bottom: 90px;
}
.APO__insertOrderD.fillcontactDetail .APO__bookingBtn {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 20px;
    width: calc(100% - 20px* 2);
    margin: 0 auto;
}
.APO__insertOrderD.fillcontactDetail .APO__orderDContent:after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    height: 1px;
    background: #e0eaf9;
    bottom: -19px;
    margin-left: -20px;
    margin-right: -20px;
}
.APO__Confirmwrapper {
    background-color: #fff;
    position: absolute;
    left: 0;
    right: 0;
    top: 0px;
    bottom: 0px;
    width: 100%;
    overflow-y: auto;
    max-height: 100%;
}
.APO__confirmContent {
    background-color: #fafafa;
    box-shadow: 0px 0px 4px rgba(39, 45, 61, 0.1), 0px 0px 4px rgba(39, 45, 61, 0.06);
}
.APO__Confirmwrapper .APO__loader{
    background-color: #2db007;
    color: #fff;
    font-size: 20px;
}

a[href="javascript:void(0)"].service-wrapper {
    cursor: no-drop;
}

/* Location css */
.locationDirectionIcon {
    position: absolute;
    top: 21px;
    right: 8px;
    z-index: 1;
    width: 30px;
    height: 19px;
}

/* loader mask screen */
.APO__screenmask {
    position: absolute;
    visibility: hidden;
    opacity: 0;
    top:0;
    bottom:0;
    left:0;
    right:0;
    background-color: rgb(255, 255, 255, 0.8);
    z-index: 10;
}
.APO__screenmask.show {
    visibility: visible;
    opacity: 1;
}
.APO__screenmask.hide .APO__loader{
    display: none;
}
.APO__loader {
    border-radius: 50%;
    position: relative;
}
.btn__loader.APO__spin {
    border-radius: 50%;
    position: relative;
    aspect-ratio: 1;
    border: 1px solid var(--primary-color);
    border-right-color: var(--primary-light-color);
    animation: APO__rotate 1s linear infinite
  }
.APO__screenmask .APO__spin {
    animation: APO__rotate 1s linear infinite
}
.APO__screenmask .APO__spin:before {
    content: "";
    position: absolute;
    inset: 0px;
    border-radius: 50%;
    border: 5px solid #1e75ff;
    animation: APO__prixClipFix 2s linear infinite ;
}

.APO__successCheck {
    background-color: #2db007;
}
.APO__successCheck, .APO__failCheck {
    animation: APO_pop 1.2s ease-in-out;
}
.APO__successCheck:before, .APO__successCheck:after{
    background-color: #fff;
    transform-origin: 0% 50%;
    content: "";
    height: 4px;
    position: absolute;
    border-radius: 5px;  
}
.APO__successCheck:before {
    width: 25.6px;
    top: 62%;
    left: 44%;
    transform: rotate(-47deg);
    animation: baseGrow 1s;
}
.APO__successCheck:after {
    width: 16px;
    top: 64%;
    left: 47%;
    transform: rotate(-135deg);
    animation: tipGrow 1s;
} 

.APO__failCheck {
    background-color: #ffcccb;
}
.APO__failCheck:before, .APO__failCheck:after {
    content: "";
    position: absolute;
    width: 32px;
    height: 4px;
    border-radius: 5px;
    background: #8b0000;
    transform-origin: 50% 50%;
    top: calc(50% - 2px);
}
.APO__failCheck:before{
    transform: rotate(45deg);
    animation: leftIn 0.3s linear;
    left: calc(50% - 16px);
}
.APO__failCheck:after {
    transform: rotate(-45deg);
    animation: rightIn 0.3s linear;
    right: calc(50% - 16px);
}

@keyframes APO_pop {
    0% {
      transform: scale(1);
    }
    80% {
      transform: scale(1);    
    }
    100% {
      transform: scale(1.1);
    }
}
@keyframes tipGrow {
    0% {
        width: 0px;
        left: 0;
        top: 0;
    }
    25% {
        width: 0px;
        left: 0;
        top: 0; 
    }
    50% {
        top: 0%;
        left: 0%;
        width: 0;
    }
    75% {
        top: 0%;
        left: 0%;
        width: 0px;
    }
    100% {
        top: 64%;
        left: 47%;
        width: 16px;
    }
}

@keyframes baseGrow {
    0% {
        width: 0;
    }
    90% {
        width: 0;
    }
    100% {
        width: 25.6px;
    }
}

@keyframes leftIn {
    0% {
      left: 0;
      top: 0;
      width: 0;
    }
    100% {
      top: calc(50% - 2px);
      left: calc(50% - 16px);
      width: 32px;
    }
}
  
  @keyframes rightIn {
    0% {
      rigth: 0;
      top: 0;
      width: 0;
    }
    100% {
      top: calc(50% - 2px);
      right: calc(50% - 16px);
      width: 32px;
    }
}

@keyframes APO__rotate {
    100%   {transform: rotate(360deg)}
}

@keyframes APO__prixClipFix {
    0%   {clip-path:polygon(50% 50%,0 0,0 0,0 0,0 0,0 0)}
    25%  {clip-path:polygon(50% 50%,0 0,100% 0,100% 0,100% 0,100% 0)}
    50%  {clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,100% 100%,100% 100%)}
    75%  {clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,0 100%,0 100%)}
    100% {clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,0 100%,0 0)}
}

`, "",{"version":3,"sources":["webpack://./css/Theme.css"],"names":[],"mappings":"AAAA;IACI,uFAAuF;IACvF,yBAAyB;AAC7B;AACA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;AACA;IACI,cAAc;AAClB;AACA;IACI,yBAAyB;IACzB,WAAW;AACf;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,oCAAoC;IACpC,cAAc;AAClB;AACA;IACI,eAAe;AACnB;AACA;IACI;;mBAEe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,eAAe;IACf,cAAc;AAClB;AACA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA,cAAc;AACd;IACI,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,oCAAoC;AACxC;;AAEA,sBAAsB;AACtB;IACI,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA,kBAAkB;AAClB;IACI,YAAY;IACZ,WAAW;IACX,eAAe;AACnB;AACA;IACI,cAAc;IACd,yBAAyB;AAC7B;AACA;IACI,WAAW;IACX,yBAAyB;AAC7B;AACA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA,yBAAyB;AACzB;IACI,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,OAAO;IACP,QAAQ;IACR,6BAA6B;IAC7B,gCAAgC;IAChC,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,yBAAyB;AAC7B;AACA;;;;;GAKG;AACH;IACI,+BAA+B;IAC/B,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;AACA;;GAEG;CACF;IACG,yBAAyB;IACzB,WAAW;IACX,eAAe;IACf,eAAe;CAClB;AACD;IACI,eAAe;IACf,qBAAqB;AACzB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,UAAU;AACd;AACA;IACI,mCAAmC;IACnC,qBAAqB;IACrB,yBAAyB;AAC7B;AACA;IACI,qBAAqB;IACrB,6BAA6B;AACjC;AACA;IACI,oBAAoB;AACxB;AACA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,2BAA2B;IAC3B,cAAc;AAClB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,QAAQ;IACR,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,yBAAyB;IACzB,iFAAiF;AACrF;AACA;IACI,yBAAyB;IACzB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA,iBAAiB;AACjB;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,UAAU;IACV,WAAW;IACX,YAAY;AAChB;;AAEA,uBAAuB;AACvB;IACI,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,KAAK;IACL,QAAQ;IACR,MAAM;IACN,OAAO;IACP,yCAAyC;IACzC,WAAW;AACf;AACA;IACI,mBAAmB;IACnB,UAAU;AACd;AACA;IACI,aAAa;AACjB;AACA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,sCAAsC;IACtC,8CAA8C;IAC9C;EACF;AACF;IACI;AACJ;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,kBAAkB;IAClB,yBAAyB;IACzB,+CAA+C;AACnD;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,mCAAmC;AACvC;AACA;IACI,sBAAsB;IACtB,wBAAwB;IACxB,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,QAAQ;IACR,SAAS;IACT,yBAAyB;IACzB,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,QAAQ;IACR,SAAS;IACT,0BAA0B;IAC1B,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,oBAAoB;AACxB;AACA;IACI,wBAAwB;IACxB,6BAA6B;IAC7B,sBAAsB;AAC1B;AACA;IACI,yBAAyB;IACzB,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI;MACE,mBAAmB;IACrB;IACA;MACE,mBAAmB;IACrB;IACA;MACE,qBAAqB;IACvB;AACJ;AACA;IACI;QACI,UAAU;QACV,OAAO;QACP,MAAM;IACV;IACA;QACI,UAAU;QACV,OAAO;QACP,MAAM;IACV;IACA;QACI,OAAO;QACP,QAAQ;QACR,QAAQ;IACZ;IACA;QACI,OAAO;QACP,QAAQ;QACR,UAAU;IACd;IACA;QACI,QAAQ;QACR,SAAS;QACT,WAAW;IACf;AACJ;;AAEA;IACI;QACI,QAAQ;IACZ;IACA;QACI,QAAQ;IACZ;IACA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;MACE,OAAO;MACP,MAAM;MACN,QAAQ;IACV;IACA;MACE,oBAAoB;MACpB,sBAAsB;MACtB,WAAW;IACb;AACJ;;EAEE;IACE;MACE,QAAQ;MACR,MAAM;MACN,QAAQ;IACV;IACA;MACE,oBAAoB;MACpB,uBAAuB;MACvB,WAAW;IACb;AACJ;;AAEA;IACI,QAAQ,yBAAyB;AACrC;;AAEA;IACI,MAAM,8CAA8C;IACpD,MAAM,0DAA0D;IAChE,MAAM,mEAAmE;IACzE,MAAM,6DAA6D;IACnE,MAAM,0DAA0D;AACpE","sourcesContent":[".APO__box-shadow {\r\n    /* box-shadow: 0px 0px 4px rgba(39, 45, 61, 0.1), 0px 0px 4px rgba(39, 45, 61, 0.06); */\r\n    border: 1px solid #e0eaf9;\r\n}\r\n.APO__custhaserror {\r\n    color: #e22727;\r\n    font-size: 14px;\r\n    margin-top: -13px;\r\n    margin-bottom: 16px;\r\n}\r\n.APO__hover:hover, .service-wrapper.selected, .APO__boxed.selected {\r\n    background-color: #fafafa;\r\n    border-color: #1e75ff;\r\n}\r\n.APO__hover:hover * {\r\n    color: #3c5d95;\r\n}\r\n.APO__hover:hover .gray-badge {\r\n    background-color: #1e75ff;\r\n    color: #fff;\r\n}\r\n.APO__hover:hover svg path{\r\n    fill: #1e75ff!important;\r\n}\r\n.APO__title {\r\n    text-transform: capitalize!important;\r\n    color: #252525;\r\n}\r\n.APO__mutetext {\r\n    font-size: 14px;\r\n}\r\n.gray-badge {\r\n    /* position: absolute;\r\n    right: 0;\r\n    bottom: 16px; */\r\n    background-color: #eaeaea;\r\n    border-radius: 5px;\r\n    padding: 1px 8px;\r\n    font-size: 14px;\r\n    line-height: normal;\r\n    color: #242627;\r\n}\r\n.APO__typeicon {\r\n    font-size: 28px;\r\n    color: #49505f;\r\n}\r\n.APO__OptionIcon {\r\n    font-size: 24px;\r\n    color: #49505f;\r\n}\r\n\r\n/* staff css */\r\n.__selectStaff hr {\r\n    width: 30px;\r\n    height: 2px;\r\n    background-color: #ccc;\r\n    border-radius: 4px;\r\n    border: none;\r\n}\r\n.__Staffname:first-letter, .__StaffRole:first-letter {\r\n    text-transform: capitalize!important;\r\n}\r\n\r\n/* boxed  design css */\r\n.APO__boxedlayout .APO__boxed {\r\n    width: calc(50% - 8px);\r\n    word-break: break-word;\r\n}\r\n\r\n/* booking slots */\r\n.APO__Timeslots {\r\n    padding: 8px;\r\n    width: 100%;\r\n    cursor: pointer;\r\n}\r\n.APO__Timeslots:not(.breakHour){\r\n    color: #1e75ff;\r\n    border: 1px solid #1e75ff;\r\n}\r\n.APO__Timeslots:hover:not(.breakHour), .APO__Timeslots.selected:not(.breakHour) {\r\n    color: #fff;\r\n    background-color: #1e75ff;\r\n}\r\n.APO__Timeslots.breakHour {\r\n    cursor: not-allowed;\r\n    background-color: #eee;\r\n    border-color: var(--gray-100);\r\n}\r\n\r\n/* order detail box css */\r\n.APO__insertOrderD {\r\n    background-color: #fafafa;\r\n    position: absolute;\r\n    bottom: -100%;\r\n    left: 0;\r\n    right: 0;\r\n    border-top: 1px solid #e0eaf9;\r\n    border-radius: 16px 16px 0px 0px;  \r\n    overflow: hidden;\r\n    max-height: 100%;\r\n}\r\n.APO__insertOrderD.orderDminimized .APO__roundedicon svg {\r\n    transform: rotate(180deg);\r\n}\r\n/* .APO__insertOrderD.orderDminimized {\r\n    bottom: -145px !important;\r\n}\r\n.APO__insertOrderD.orderDminimized .APO__orderDContent, .APO__insertOrderD.orderDminimized .APO__bookingBtn {\r\n    display: none;\r\n} */\r\n.APO__insertOrderD.fillcontactDetail {\r\n    /* height: calc(100% - 67px); */\r\n    /* top: 64px; */\r\n    border-radius: 0px;\r\n    overflow-y: auto;\r\n    border-top: none;\r\n}\r\n/* .APO__insertOrderD.fillcontactDetail::-webkit-scrollbar {\r\n    display: none;\r\n} */\r\n .tryAgainBtn{\r\n    background-color: #f34e52;   \r\n    color: #fff;\r\n    font-size: 17px;\r\n    cursor: pointer;\r\n }\r\n.APO__orderDright {\r\n    max-width: 60px;\r\n    word-wrap: break-word;\r\n}\r\n.APO__orderDetail .APO__title{\r\n    font-size: 17px!important;\r\n}\r\n.APO__AllbooikgList .addnewAPO {\r\n    position: absolute;\r\n    right: 10px;\r\n    left: auto;\r\n    width: 40px;\r\n    height: 40px;\r\n    border-radius: 50%;\r\n    bottom: 32px;\r\n    padding: 0;\r\n    z-index: 1;\r\n}\r\n.APO__bookingBtn{\r\n    background-color: #1e75ff!important;   \r\n    color: #fff!important;\r\n    cursor: pointer!important;\r\n}\r\n.APO__bookingBtn:disabled {\r\n    opacity: .5!important;\r\n    cursor: not-allowed!important;\r\n}\r\n.APO__insertOrderD.fillcontactDetail .APO__orderDetail{\r\n    padding-bottom: 90px;\r\n}\r\n.APO__insertOrderD.fillcontactDetail .APO__bookingBtn {\r\n    position: absolute;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 20px;\r\n    width: calc(100% - 20px* 2);\r\n    margin: 0 auto;\r\n}\r\n.APO__insertOrderD.fillcontactDetail .APO__orderDContent:after {\r\n    content: \"\";\r\n    position: absolute;\r\n    left: 0;\r\n    right: 0;\r\n    height: 1px;\r\n    background: #e0eaf9;\r\n    bottom: -19px;\r\n    margin-left: -20px;\r\n    margin-right: -20px;\r\n}\r\n.APO__Confirmwrapper {\r\n    background-color: #fff;\r\n    position: absolute;\r\n    left: 0;\r\n    right: 0;\r\n    top: 0px;\r\n    bottom: 0px;\r\n    width: 100%;\r\n    overflow-y: auto;\r\n    max-height: 100%;\r\n}\r\n.APO__confirmContent {\r\n    background-color: #fafafa;\r\n    box-shadow: 0px 0px 4px rgba(39, 45, 61, 0.1), 0px 0px 4px rgba(39, 45, 61, 0.06);\r\n}\r\n.APO__Confirmwrapper .APO__loader{\r\n    background-color: #2db007;\r\n    color: #fff;\r\n    font-size: 20px;\r\n}\r\n\r\na[href=\"javascript:void(0)\"].service-wrapper {\r\n    cursor: no-drop;\r\n}\r\n\r\n/* Location css */\r\n.locationDirectionIcon {\r\n    position: absolute;\r\n    top: 21px;\r\n    right: 8px;\r\n    z-index: 1;\r\n    width: 30px;\r\n    height: 19px;\r\n}\r\n\r\n/* loader mask screen */\r\n.APO__screenmask {\r\n    position: absolute;\r\n    visibility: hidden;\r\n    opacity: 0;\r\n    top:0;\r\n    bottom:0;\r\n    left:0;\r\n    right:0;\r\n    background-color: rgb(255, 255, 255, 0.8);\r\n    z-index: 10;\r\n}\r\n.APO__screenmask.show {\r\n    visibility: visible;\r\n    opacity: 1;\r\n}\r\n.APO__screenmask.hide .APO__loader{\r\n    display: none;\r\n}\r\n.APO__loader {\r\n    border-radius: 50%;\r\n    position: relative;\r\n}\r\n.btn__loader.APO__spin {\r\n    border-radius: 50%;\r\n    position: relative;\r\n    aspect-ratio: 1;\r\n    border: 1px solid var(--primary-color);\r\n    border-right-color: var(--primary-light-color);\r\n    animation: APO__rotate 1s linear infinite\r\n  }\r\n.APO__screenmask .APO__spin {\r\n    animation: APO__rotate 1s linear infinite\r\n}\r\n.APO__screenmask .APO__spin:before {\r\n    content: \"\";\r\n    position: absolute;\r\n    inset: 0px;\r\n    border-radius: 50%;\r\n    border: 5px solid #1e75ff;\r\n    animation: APO__prixClipFix 2s linear infinite ;\r\n}\r\n\r\n.APO__successCheck {\r\n    background-color: #2db007;\r\n}\r\n.APO__successCheck, .APO__failCheck {\r\n    animation: APO_pop 1.2s ease-in-out;\r\n}\r\n.APO__successCheck:before, .APO__successCheck:after{\r\n    background-color: #fff;\r\n    transform-origin: 0% 50%;\r\n    content: \"\";\r\n    height: 4px;\r\n    position: absolute;\r\n    border-radius: 5px;  \r\n}\r\n.APO__successCheck:before {\r\n    width: 25.6px;\r\n    top: 62%;\r\n    left: 44%;\r\n    transform: rotate(-47deg);\r\n    animation: baseGrow 1s;\r\n}\r\n.APO__successCheck:after {\r\n    width: 16px;\r\n    top: 64%;\r\n    left: 47%;\r\n    transform: rotate(-135deg);\r\n    animation: tipGrow 1s;\r\n} \r\n\r\n.APO__failCheck {\r\n    background-color: #ffcccb;\r\n}\r\n.APO__failCheck:before, .APO__failCheck:after {\r\n    content: \"\";\r\n    position: absolute;\r\n    width: 32px;\r\n    height: 4px;\r\n    border-radius: 5px;\r\n    background: #8b0000;\r\n    transform-origin: 50% 50%;\r\n    top: calc(50% - 2px);\r\n}\r\n.APO__failCheck:before{\r\n    transform: rotate(45deg);\r\n    animation: leftIn 0.3s linear;\r\n    left: calc(50% - 16px);\r\n}\r\n.APO__failCheck:after {\r\n    transform: rotate(-45deg);\r\n    animation: rightIn 0.3s linear;\r\n    right: calc(50% - 16px);\r\n}\r\n\r\n@keyframes APO_pop {\r\n    0% {\r\n      transform: scale(1);\r\n    }\r\n    80% {\r\n      transform: scale(1);    \r\n    }\r\n    100% {\r\n      transform: scale(1.1);\r\n    }\r\n}\r\n@keyframes tipGrow {\r\n    0% {\r\n        width: 0px;\r\n        left: 0;\r\n        top: 0;\r\n    }\r\n    25% {\r\n        width: 0px;\r\n        left: 0;\r\n        top: 0; \r\n    }\r\n    50% {\r\n        top: 0%;\r\n        left: 0%;\r\n        width: 0;\r\n    }\r\n    75% {\r\n        top: 0%;\r\n        left: 0%;\r\n        width: 0px;\r\n    }\r\n    100% {\r\n        top: 64%;\r\n        left: 47%;\r\n        width: 16px;\r\n    }\r\n}\r\n\r\n@keyframes baseGrow {\r\n    0% {\r\n        width: 0;\r\n    }\r\n    90% {\r\n        width: 0;\r\n    }\r\n    100% {\r\n        width: 25.6px;\r\n    }\r\n}\r\n\r\n@keyframes leftIn {\r\n    0% {\r\n      left: 0;\r\n      top: 0;\r\n      width: 0;\r\n    }\r\n    100% {\r\n      top: calc(50% - 2px);\r\n      left: calc(50% - 16px);\r\n      width: 32px;\r\n    }\r\n}\r\n  \r\n  @keyframes rightIn {\r\n    0% {\r\n      rigth: 0;\r\n      top: 0;\r\n      width: 0;\r\n    }\r\n    100% {\r\n      top: calc(50% - 2px);\r\n      right: calc(50% - 16px);\r\n      width: 32px;\r\n    }\r\n}\r\n\r\n@keyframes APO__rotate {\r\n    100%   {transform: rotate(360deg)}\r\n}\r\n\r\n@keyframes APO__prixClipFix {\r\n    0%   {clip-path:polygon(50% 50%,0 0,0 0,0 0,0 0,0 0)}\r\n    25%  {clip-path:polygon(50% 50%,0 0,100% 0,100% 0,100% 0,100% 0)}\r\n    50%  {clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,100% 100%,100% 100%)}\r\n    75%  {clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,0 100%,0 100%)}\r\n    100% {clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,0 100%,0 0)}\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
